/*
 *
 * Producer -- Rowe
 * Time -- 2017/9/4
 * Function -- 404
 *
 */
import React from 'react';

import { getEnv } from "../../../../configuration/ConfigExpr";


class ErrorBody extends React.Component{
    constructor(props){
        super(props);
        this.goWhere = this.goWhere.bind(this);
    }
    
    goWhere(address){
        window.location.href=address;
    }
    render(){

        let LocationHost = getEnv( process.title, "localhost" );

        return (
            <div className="sepError clearFix">
                <div className="banner">
                    <div className="center">
                        <div className="goButton" onClick={ this.goWhere.bind(this,`/`) }>
                            <p>逛逛别的</p>
                            <p> > </p>
                        </div>
                    </div>
                </div>
                <div className="buttonArea">
                    <div className="center">
                        <div className="module">
                            <div className="text">
                                <p>畅销榜单</p>
                                <p>
                                    <span>HOT</span>
                                    <span>SALES</span>
                                </p>
                            </div>
                            <div className="goWhereButton" onClick={ this.goWhere.bind(this,`http://${LocationHost}/rank/`) }>
                                <p>立即前往</p>
                                <p> > </p>
                            </div>
                        </div>
                        <div className="module Ml70">
                            <div className="text">
                                <p>礼物套装</p>
                                <p>
                                    <span>GIFT</span>
                                    <span>SETS</span>
                                </p>
                            </div>
                            <div className="goWhereButton" onClick={ this.goWhere.bind(this,'/gift_set.html') }>
                                <p>立即前往</p>
                                <p> > </p>
                            </div>
                        </div>
                        <div className="module Ml70">
                            <div className="text">
                                <p>每周特惠</p>
                                <p>
                                    <span>WEEKLY</span>
                                    <span>SPECIAL</span>
                                </p>
                            </div>
                            <div className="goWhereButton" onClick={ this.goWhere.bind(this,`http://${LocationHost}/campaign/weeklyspecials0323/`) }>
                                <p>立即前往</p>
                                <p> > </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ErrorBody;


// WEBPACK FOOTER //
// ./common/components/organisms/Error/index.js